import React from 'react';
import { UserCircle, Eye, Mail, Globe, Send, Users, GraduationCap, FileText } from 'lucide-react';

function GovernmentLinksBar() {
  const links = [
    {
      name: 'Subhadra',
      url: 'https://subhadra.odisha.gov.in/',
      icon: UserCircle,
      color: '#f59e0b'
    },
    {
      name: 'Odisha Vision',
      url: 'https://vision.odisha.gov.in/',
      icon: Eye,
      color: '#ef4444'
    },
    {
      name: 'OMail',
      url: 'https://mail.odisha.gov.in/',
      icon: Mail,
      color: '#10b981'
    },
    {
      name: 'Odisha One',
      url: 'https://www.odishaone.gov.in/citizen/',
      icon: Globe,
      color: '#3b82f6'
    },
    {
      name: 'eDespatch',
      url: 'https://edodisha.gov.in/',
      icon: Send,
      color: '#8b5cf6'
    },
    {
      name: 'Janasunani',
      url: 'https://janasunani.odisha.gov.in/',
      icon: Users,
      color: '#06b6d4'
    },
    {
      name: 'ePravesh',
      url: 'https://epravesh.odisha.gov.in/',
      icon: GraduationCap,
      color: '#f97316'
    },
    {
      name: 'Tender & Advt.',
      url: 'https://balasore.odisha.gov.in/en/tenders-advertisements',
      icon: FileText,
      color: '#ec4899'
    }
  ];

  return (
    <div className="gov-links-container">
      <div className="pattern-background">
        <svg className="pattern-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 100" preserveAspectRatio="none">
          <pattern id="people-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="10" r="6" fill="rgba(255,255,255,0.1)" />
            <ellipse cx="20" cy="25" rx="10" ry="12" fill="rgba(255,255,255,0.1)" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#people-pattern)" />
        </svg>
      </div>
      <div className="links-wrapper">
        {links.map((link, index) => {
          const IconComponent = link.icon;
          return (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="gov-link-item"
            >
              <div className="icon-circle">
                <div className="icon-inner" style={{ backgroundColor: link.color }}>
                  <IconComponent size={28} strokeWidth={2} color="white" />
                </div>
              </div>
              <span className="link-text">{link.name}</span>
            </a>
          );
        })}
      </div>

      <style>{`
        .gov-links-container {
          position: relative;
          background: linear-gradient(135deg, #0c5d92 0%, #1e7bb8 100%);
          padding: 15px 20px;
          overflow: hidden;
        }

        .gov-links-container .pattern-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 50%;
          height: 100%;
          background: rgba(255, 255, 255, 0.03);
          clip-path: polygon(0 0, 100% 0, 70% 100%, 0 100%);
          z-index: 0;
        }

        .gov-links-container .pattern-svg {
          width: 100%;
          height: 100%;
          opacity: 0.3;
        }

        .gov-links-container .links-wrapper {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 30px;
          flex-wrap: wrap;
          max-width: 1400px;
          margin: 0 auto;
          z-index: 1;
        }

        .gov-links-container .gov-link-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .gov-links-container .gov-link-item:hover {
          transform: translateY(-5px);
        }

        .gov-links-container .icon-circle {
          width: 60px;
          height: 60px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          transition: box-shadow 0.3s ease;
          padding: 3px;
        }

        .gov-links-container .gov-link-item:hover .icon-circle {
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
        }

        .gov-links-container .icon-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .gov-links-container .link-text {
          color: white;
          font-size: 13px;
          font-weight: 500;
          text-align: center;
          white-space: nowrap;
        }

        @media (max-width: 1024px) {
          .gov-links-container .links-wrapper {
            gap: 20px;
          }

          .gov-links-container .icon-circle {
            width: 50px;
            height: 50px;
          }

          .gov-links-container .icon-inner svg {
            width: 22px;
            height: 22px;
          }

          .gov-links-container .link-text {
            font-size: 12px;
          }
        }

        @media (max-width: 768px) {
          .gov-links-container {
            padding: 12px 15px;
          }

          .gov-links-container .links-wrapper {
            gap: 15px;
          }

          .gov-links-container .icon-circle {
            width: 45px;
            height: 45px;
          }

          .gov-links-container .icon-inner svg {
            width: 20px;
            height: 20px;
          }

          .gov-links-container .link-text {
            font-size: 11px;
          }
        }
      `}</style>
    </div>
  );
}

export default GovernmentLinksBar;